<template>
  <div>
    <div class="file-list-section">
      <div
        v-for="(file, index) in attachmentList"
        :key="index"
        class="custom-badge"
      >
        <div class="d-flex custom-file-name" @click="clickDownloadFile(file)">
          <span
            v-if="hasString(file.originalFileName)"
            class="custom-text-break"
            >{{ file.originalFileName }}</span
          >
          <span v-else class="custom-text-break">{{ file.name }}</span>
        </div>
        <div v-if="isShowDeleteIcon(file)" @click="clickDeleteFile(file)">
          <feather-icon
            icon="XIcon"
            class="custom-margin--icon delete-file-icon"
          />
        </div>
      </div>
    </div>
    <!-- start modal delete access-->
    <molecule-modal-dialog
      v-for="(attachment, index) in attachmentList"
      :key="index"
      :modalId="`${attachment.id}modal-confirm-delete-attachment`"
      icon="AlertCircleIcon"
      textTitle="Do you want to delete?"
      textSubtitle="You won’t be able to revert this!"
      buttonTextLeft="Delete"
      buttonTextRight="Cancel"
      buttonColorLeft="danger"
      :isTextCenter="true"
      @clickButtonLeft="onClickConfirmDeleteAttachmentFromModal"
    >
    </molecule-modal-dialog>
    <!-- end modal delete access -->
  </div>
</template>

<script>
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"

import { mapGetters } from "vuex"
import mixinsValidator from "@/mixins/mixinsValidator"
import mixins from "@/mixins"

export default {
  name: "AtomFileAttachmentList",

  components: {
    MoleculeModalDialog,
  },

  props: {
    attachmentList: {
      type: Array,
      required: false,
      default: () => [],
      // NOTE that attachment list required [{"id", "name", "path"}] property.
    },
    isDeletable: {
      type: Boolean,
      required: false,
      default: true,
      // NOTE that this prop enable/disable delete icon.
    },
    isCheckOwnerPermissionDelete: {
      type: Boolean,
      required: false,
      default: false,
      // NOTE that this prop will apply with "isDeletable" prop, add condition to show delete icon.
    },
    hasModalConfirmDelete: {
      type: Boolean,
      required: false,
      default: true,
      // NOTE that this prop enable/disable confirm delete modal.
    },
    forceClearFileValue: {
      type: Number,
      required: false,
      default: 0,
    },
    // NOTE that this prop use for clear file list when it change.
  },

  emits: ["onRequestDeleteAttachment"],

  mixins: [mixins ,mixinsValidator],

  data() {
    return {
      modalId: "",
      targetFile: null,
    }
  },

  computed: {
    ...mapGetters("appPermission", ["getInternalUserName", "getUserName"]),

    isInternalAccess() {
      return this.$route.meta.type === "internal"
    },

    ownerUsername() {
      return this.isInternalAccess ? this.getInternalUserName : this.getUserName
    },
  },

  watch: {
    forceClearFileValue() {
      this.fileAttachment = []
    },
  },

  methods: {
    isShowDeleteIcon(file) {
      if (!this.isDeletable) {
        return false
      } else {
        if (!this.isCheckOwnerPermissionDelete) {
          return true
        } else {
          return this.ownerUsername === file.createdBy
        }
      }
    },

    async clickDownloadFile(file) {
      try {
        const fileUrl = file.path
        if (!fileUrl) throw error
        const response = await fetch(fileUrl)
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const link = document.createElement("a")
        const filename = file.originalFileName || file.name
        link.href = url
        link.download = filename
        link.click()
        URL.revokeObjectURL(url)
        this.toastSuccess("Download File Successfully")
      } catch (error) {
        this.toastError("Download File Failed")
      }
    },

    clickDeleteFile(file) {
      if (!this.hasModalConfirmDelete) {
        this.$emit("onRequestDeleteAttachment", file)
      } else {
        this.modalId = `${file.id}modal-confirm-delete-attachment`
        this.$bvModal.show(this.modalId)
        this.targetFile = file
      }
    },

    onClickConfirmDeleteAttachmentFromModal() {
      this.$emit("onRequestDeleteAttachment", this.targetFile)
      this.closeModal()
      this.targetFile = null
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
  },
}
</script>

<style lang="scss" scoped>
.file-list-section {
  display: flex;
  flex-wrap: wrap;
}

.custom-badge {
  display: flex;
  background-color: #eeecfd;
  border-radius: 4px;
  padding: 1px 9px;
  text-decoration-line: underline;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  width: fit-content;
  margin: 5px 10px 5px 0;

  &:hover {
    background-color: #dfdbff;
    cursor: pointer;
  }
}

.custom-margin--icon {
  margin-left: 5px;
}
</style>
